export default __webpack_public_path__ + "c27d50352ac6cc4f44fa050434d9fca3.svg";